import React from 'react';

interface Props {
  startTime: string;
  endTime: string;
}

const EventTime = ({ startTime, endTime }: Props) => {
  if (!startTime) {
    return null;
  }

  if (startTime === endTime || (startTime && !endTime)) {
    return <>{startTime}</>;
  }

  return <>{`${startTime}-${endTime}`}</>;
};
export default EventTime;
